/* Copyright (c) 2017 Backpack Health LLC */
/* global IS_ANDROID_BUILD */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import SetPassword from '../views/SetPassword';
import MfaVerification from '../views/MfaVerification';
import AppUtils from '../../../utilities/AppUtils';
// import UserService from '../../../apiServices/UserService';
import SessionService from '../../../apiServices/SessionService';
import PasswordService from '../../../apiServices/PasswordService';

function login(email, password) {
  SessionService.login({
    email,
    password,
    duration: 'short',
  }, (apiError) => {
    if (!apiError) {
      AppUtils.reloadApp();
    }
  });
}

class ResetForgottenPassword extends React.Component {

  constructor(props) {
    super(props);

    this.cancelPasswordReset = this.cancelPasswordReset.bind(this);
    this.onSubmitValidPassword = this.onSubmitValidPassword.bind(this);
    this.submitMfaCode = this.submitMfaCode.bind(this);
    this.cancelMfaCode = this.cancelMfaCode.bind(this);

    this.state = {
      password: '',
      errorMessage: '',
    };
  }

  onSubmitValidPassword(password) {
    if (this.props.isMfaEnabled) {
      this.setState({
        password,
      });

      return;
    }

    PasswordService.update(
      this.props.token,
      password,
      (apiError, user) => {
        if (!apiError) {
          login(user.data.email, password);
        }
      }
    );
  }

  submitMfaCode(mfaCode) {
    if (!mfaCode) {
      this.setState({
        errorMessage: <FormattedMessage id="error.2fa-code-validator.message" />,
      });
      return;
    }

    SessionService.mfaForgotPassword(mfaCode, this.state.password, this.props.token, 'short', (apiError) => {
      if (apiError) {
        this.setState({
          errorMessage: <FormattedMessage id={apiError.messageKey()} />,
        });
      } else {
        AppUtils.reloadApp();
      }
    });
  }

  cancelPasswordReset() {
    AppUtils.logout({}, AppUtils.reloadApp);
  }

  cancelMfaCode() {
    this.setState({
      password: '',
    });
  }

  render() {
    if (!this.state.password) {
      return (
        <SetPassword
          title="setPwd.title.text"
          onCancel={this.cancelPasswordReset}
          onSubmit={this.onSubmitValidPassword}
          showStrength
          allowLanguageToggle={!IS_ANDROID_BUILD}
        />
      );
    } else {
      return (
        <MfaVerification
          token={this.props.token}
          submitMfaCode={this.submitMfaCode}
          cancelMfa={this.cancelMfaCode}
          errorMessage={this.state.errorMessage}
          clearError={() => { this.setState({ errorMessage: '' }); }}
        />
      );
    }
  }
}
ResetForgottenPassword.propTypes = {
  token: PropTypes.string.isRequired,
  isMfaEnabled: PropTypes.bool,
};

export default ResetForgottenPassword;
